import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.find-index";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { deepClone } from '@/modules/mm-utils';
var workerDaysByArg = false;
var workerDays = false;
export default {
  get: function get(key1) {
    var _workerDaysByArg;

    return (_workerDaysByArg = workerDaysByArg) === null || _workerDaysByArg === void 0 ? void 0 : _workerDaysByArg[key1];
  },
  getByParams: function getByParams(params) {
    var _workerDays;

    var dayId = Object.keys(workerDays).filter(function (dayId) {
      var day = workerDays[dayId];
      var dt = day['dt'] === params['dt'];
      var workerId = day['worker_id'] === params['worker_id'];
      var approved = day['is_approved'] === params['is_approved'];
      var fact = day['is_fact'] === params['is_fact'];

      if (dt && workerId && approved && fact) {
        return true;
      }
    });
    return (_workerDays = workerDays) === null || _workerDays === void 0 ? void 0 : _workerDays[dayId[dayId.length - 1]];
  },
  add: function add(key1, key2, value) {
    if (!workerDaysByArg) workerDaysByArg = {};
    if (!workerDaysByArg[key1]) workerDaysByArg[key1] = {};
    var workerDay = workerDaysByArg[key1][key2];

    if (!workerDay) {
      workerDaysByArg[key1][key2] = _objectSpread(_objectSpread({}, value), {}, {
        shiftCount: 1,
        shifts: [value]
      });
    } else {
      var foundIndex = workerDay.shifts.findIndex(function (shift) {
        return shift.id === value.id;
      });

      if (foundIndex === -1) {
        workerDay.shiftCount++;
        workerDay.shifts.push(value);
      } else {
        workerDay.shifts.splice(foundIndex, 1, value); // ! Мутация стэйта!!!!!
      }
    }

    this.addById(value);
  },
  addById: function addById(value) {
    if (!workerDays) workerDays = {};
    workerDays[value.id] = value;
  },
  hasValues: function hasValues(key1) {
    if (key1) {
      var _workerDaysByArg2;

      return !!((_workerDaysByArg2 = workerDaysByArg) !== null && _workerDaysByArg2 !== void 0 && _workerDaysByArg2.key1);
    }

    return !!workerDaysByArg;
  },
  purge: function purge() {
    workerDaysByArg = false;
    workerDays = false;
  },
  clone: function clone() {
    workerDaysByArg = deepClone(workerDaysByArg);
    workerDays = deepClone(workerDays);
  },
  log: function log() {
    console.log(workerDays);
  }
};